import { message, Space, Tabs } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
  ModalItem,
  ButtonItem,
  Form,
  FormItem,
  InputItem,
  ErrorItem,
} from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import facturaXmlPdf from "../../../../Pdf/facturaXmlPdf";
import complementoXmlPdf from "../../../../Pdf/complementoXmlPdf";
import { extraerDatosDesdeArbol, resolverProveedorPorRfc } from "../xmlConceptosHelpers";
import ConceptosXmlTable from "../ConceptosXmlTable";
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { TabPane } = Tabs;

class VistaPrevia extends Component {
  formRef = React.createRef();
  state = {
    loading: false,
    pdf: null,
    emitido: false,
    tipoDeComprobante: null,
    conceptos: null,
    rfcEmisor: null,
    nombreEmisor: null,
    monedaAbrev: null,
    todasProveedoresLocal: this.props.todasProveedores || [],
  };

  componentDidUpdate(prevProps) {
    if (prevProps.todasProveedores !== this.props.todasProveedores) {
      this.setState({ todasProveedoresLocal: this.props.todasProveedores || [] });
    }
    if (this.props.visible !== prevProps.visible && this.props.visible)
      this.consultarTodo();
  }

  onProveedorAlta(proveedorNuevo) {
    this.setState((prev) => ({ todasProveedoresLocal: [...prev.todasProveedoresLocal, proveedorNuevo] }));
    if (this.props.onProveedorAlta) this.props.onProveedorAlta(proveedorNuevo);
  }
  async consultarTodo() {
    this.setState({ loading: true });
    await axios
      .post(
        "descargaMasiva/datosXml",
        { xmlId: this.props.id, empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.formRef.current.setFieldsValue({
          correo: res.data?.cliente?.correo ? res.data.cliente.correo : "",
        });
        let pdf
        if(res.data.tipoDeComprobante === 'I' || res.data.tipoDeComprobante === 'E'){
          pdf = pdfMake.createPdf(facturaXmlPdf(res.data));
        }else if(res.data.tipoDeComprobante === 'P'){
          pdf = pdfMake.createPdf(complementoXmlPdf(res.data));
        }

        let conceptos = null;
        let rfcEmisor = null;
        let nombreEmisor = null;
        let monedaAbrev = null;
        if (res.data.tipoDeComprobante === 'I' || res.data.tipoDeComprobante === 'E') {
          const datos = extraerDatosDesdeArbol(res.data.dataXml);
          conceptos = datos.conceptos;
          rfcEmisor = datos.rfcEmisor;
          nombreEmisor = datos.nombreEmisor;
          monedaAbrev = datos.monedaAbrev;
        }

        this.setState(
          {
            loading: false,
            pdf: pdf,
            emitido: res.data.emitido,
            tipoDeComprobante: res.data.tipoDeComprobante,
            conceptos,
            rfcEmisor,
            nombreEmisor,
            monedaAbrev,
          },
          () => {
            pdf.open({}, window.frames["facturaPdf"]);
          }
        );
      });
    this.setState({ loading: false });
  }
  onFinishFailed(e) {
    ErrorItem(e);
  }
  onFinish(values) {
    this.setState({ loading: true });
    axios
      .post(
        "descargaMasiva/enviarCorreo",
        { ...values, xmlId: this.props.id, empresaId: this.props.empresaId },
        {
          headers: this.props.headersToken,
        }
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) {
          message.success("Factura enviada");
          this.formRef.current.resetFields();
          this.cerrarVistaPrevia();
        } else if (res.data.success === 1) {
          message.error("No se pudo enviar la factura a ese correo");
        } else {
          message.error("Sucedio un error y no se pudo enviar");
        }
      });
  }
  cerrarVistaPrevia() {
    this.props.cerrarVistaPrevia();
  }
  renderFactura() {
    return (
      <>
        <Form
          ref={this.formRef}
          name="vistaPrevia"
          layout
          width={700}
          onCancel={this.cerrarVistaPrevia.bind(this)}
          onFinish={this.onFinish.bind(this)}
          onFinishFailed={this.onFinishFailed}
        >
          {this.state.emitido && (this.state.tipoDeComprobante === 'I' || this.state.tipoDeComprobante === 'E' || this.state.tipoDeComprobante === 'P') && (
            <>
              <FormItem label="Correo" name="correo" pattern email margin>
                <InputItem placeholder="Correo" />
              </FormItem>
              <div
                style={{
                  display: "flex",
                  justifyContent: "right",
                  marginTop: 20,
                  marginBottom: 10,
                }}
              >
                <Space>
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Mandar Correo
                  </ButtonItem>
                  <ButtonItem
                    type="primary"
                    danger
                    onClick={this.cerrarVistaPrevia.bind(this)}
                    style={{ display: "block", margin: "0 0 0 auto" }}
                  >
                    Cancelar
                  </ButtonItem>
                </Space>
              </div>
            </>
          )}
        </Form>
        <iframe
          title={"factura"}
          style={{ width: "100%", height: "100vh" }}
          id="facturaPdf"
          name="facturaPdf"
        />
      </>
    );
  }

  render() {
    const esFacturaConConceptos = this.state.tipoDeComprobante === 'I' || this.state.tipoDeComprobante === 'E';

    return (
      <ModalItem
        title="Vista previa"
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={this.cerrarVistaPrevia.bind(this)}
        paddingTop
      >
        {esFacturaConConceptos ? (
          <Tabs defaultActiveKey="factura">
            <TabPane tab="Factura" key="factura">
              {this.renderFactura()}
            </TabPane>
            <TabPane tab="Conceptos" key="conceptos">
              <ConceptosXmlTable
                empresaId={this.props.empresaId}
                headersToken={this.props.headersToken}
                proveedorId={resolverProveedorPorRfc(this.state.todasProveedoresLocal, this.state.rfcEmisor)?._id}
                proveedorRfc={this.state.rfcEmisor}
                proveedorNombre={this.state.nombreEmisor}
                monedaAbrev={this.state.monedaAbrev}
                todasTiposDeProveedor={this.props.todasTiposDeProveedor}
                todasMonedas={this.props.todasMonedas}
                conceptos={this.state.conceptos}
                onProveedorAlta={this.onProveedorAlta.bind(this)}
              />
            </TabPane>
          </Tabs>
        ) : (
          this.renderFactura()
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(VistaPrevia);
